import { render, staticRenderFns } from "./SideBySideContentAndImage.vue?vue&type=template&id=2c1854f9&"
import script from "./SideBySideContentAndImage.vue?vue&type=script&lang=js&"
export * from "./SideBySideContentAndImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports